import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/homonym",
 headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) config.headers.Authorization = `Bearer ${token}`;
 return config;
});

const handle = (promise) =>
 promise
 .then((res) => ({ status: res.status, data: res.data }))
 .catch((err) => ({
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Request failed",
 }));

export const fetchHomonyms = (params) => handle(api.get("", { params }));
export const fetchHomonymById = (id) => handle(api.get(`/${id}`));
export const createHomonym = (data) => handle(api.post("", data));
export const updateHomonym = (id, data) => handle(api.put(`/${id}`, data));
export const deleteHomonym = (id) => handle(api.delete(`/${id}`));
export const searchHomonyms = (params) => handle(api.get("/search", { params }));
